"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var NORTH_AMERICA = '877 929 0687';
var US_SPANISH_AND_ENGLISH = '857 829 5064';
var DEFAULT = '877 929 0687'; // Phone numbers are from here: https://www.hubspot.com/company/contact

var _default = {
  de: {
    en: '+49 69 153253503',
    de: '+49 32 221094286'
  },
  'en-au': {
    en: '+61 2 8046 6514'
  },
  'en-ca': {
    en: NORTH_AMERICA
  },
  'en-gb': {
    en: '+44 20 3514 0663'
  },
  'en-ie': {
    en: '+353 1 512 4400'
  },
  'en-in': {
    en: DEFAULT
  },
  'en-nz': {
    en: '+64 9 801 1072'
  },
  'en-us': {
    en: NORTH_AMERICA
  },
  en: {
    en: NORTH_AMERICA
  },
  'es-ar': {
    en: US_SPANISH_AND_ENGLISH
  },
  'es-mx': {
    en: '+56 55 8525 9498'
  },
  es: {
    en: US_SPANISH_AND_ENGLISH
  },
  fi: {
    en: '+358 7 5325 2986'
  },
  fr: {
    en: '+33 1 84 88 62 37',
    fr: '+33 1 86 26 07 91'
  },
  it: {
    en: DEFAULT
  },
  ja: {
    en: '+81 3 6863 5289'
  },
  nl: {
    en: '+31 85 888 0286'
  },
  'pt-br': {
    en: '+55 21 2018 1092'
  },
  sv: {
    en: '+46 7 7421 8808'
  },
  'zh-cn': {
    en: DEFAULT
  },
  'zh-hk': {
    en: '+852 3008 5689'
  },
  DEFAULT: DEFAULT
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/constants/salesPhoneNumbers.js
// module id = 451
// module chunks = 5 6